import React from 'react'

const PageNoteFound = () => {
  return (
    <div className="text-white">PageNoteFound</div>
  )
}

export default PageNoteFound